import router from '@/router';

export const types = {
	Token: 'TOKEN',
	Refresh_token: 'REFRESH_TOKEN',
	Expiresat: 'EXPIRESAT',
	Refresh_token_expiresat: 'REFRESH_TOKEN_EXPIRESAT',
	openId: 'openId',
};

export function getToken(types) {
	return localStorage.getItem(types);
}

export function setToken({
	Token,
	Refresh_token,
	Expiresat,
	Refresh_token_expiresat,
}) {
	localStorage.setItem(types.Token, Token);
	localStorage.setItem(types.Refresh_token, Refresh_token);
	localStorage.setItem(
		types.Refresh_token_expiresat,
		Refresh_token_expiresat
	);
	localStorage.setItem(types.Expiresat, Expiresat);
}

export function BindweChat() {
	localStorage.setItem(types.openId, 1);
}

export function getBindweChat() {
	return localStorage.getItem(types.openId);
}

export function removeToken() {
	localStorage.removeItem(types.Token);
	localStorage.removeItem(types.Refresh_token);
	localStorage.removeItem(types.Refresh_token_expiresat);
	localStorage.removeItem(types.Expiresat);
	localStorage.removeItem(types.openId);
	router.replace('/login');
}
